// extracted by mini-css-extract-plugin
module.exports = {"facts":"Facts_facts__2PL-K","hero":"Facts_hero__3vBPc","title":"Facts_title__3IEbR","dog1":"Facts_dog1__1HAHM","dog2":"Facts_dog2__39ofY"};